import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgApplePay = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.36,
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", { d: "M6 4.67c-2 0-2.67 2-2.67 3.66 0 2 1.34 5 2.67 5 .73-.03 1.12-.33 2-.33s1 .33 2 .33 2.67-2 2.67-3.33c-.02 0-1.65-.27-1.67-2-.01-1.45 1.61-1.97 1.67-2a3.5 3.5 0 0 0-2.34-1.33c-.95-.08-1.88.66-2.33.66s-1.27-.66-2-.66m2-2a1.33 1.33 0 0 0 1.33-1.34A1.33 1.33 0 0 0 8 2.67" })
	})
});
export default SvgApplePay;
